import { render, staticRenderFns } from "./Fences.vue?vue&type=template&id=83fe0932&scoped=true"
import script from "./Fences.vue?vue&type=script&lang=js"
export * from "./Fences.vue?vue&type=script&lang=js"
import style0 from "./Fences.vue?vue&type=style&index=0&id=83fe0932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fe0932",
  null
  
)

export default component.exports